import React, { Fragment, useState, useEffect } from "react";
import Navbar from "../Navbar";
import Footer from "../Footer";
import { useTranslation } from 'react-i18next';
import { Container, Form, Row, Col, Card, Button, CardBody } from "react-bootstrap";
import Cookies from 'js-cookie';
import AOS from 'aos';
import 'aos/dist/aos.css';
const { config } = require('../api/api');



function MotorInsuranceThirdParty() {
  const base_url = config.baseURL;

  const lnstr = Cookies.get('langData') ? Cookies.get('langData') : 'en';


  const { t } = useTranslation();

  const [formData, setFormData] = useState({
    insurancetype: '',
  });

  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showSection, setShowSection] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [isHovered1, setIsHovered1] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(false);

 const [vendorKey,setVendorkey]=useState(null);
  const handleOptionChange = (e) => {
    const name=e.target.name;
    const value=e.target.value;
    const plan_id= e.target.getAttribute('data-name');
    setSelected((data)=>(
      {...data,
      planType:"Third Party",
      plan:value,
      product:name,
      planId:plan_id
    }
    ));
    debugger
   

    if (e.target.value === ' ') {
      setShowSection(true);
      setButtonDisabled(true);
    }
    else {
      setShowSection(false);
      setButtonDisabled(false);
    }

  };

 

  useEffect(()=>{
    const planvalue = sessionStorage.getItem('seletedplan');
    if(planvalue != undefined) {
      const plan = JSON.parse(planvalue)
      setSelected(plan)
    }
  },[])


  useEffect(()=>{
    AOS.init({duration:600});
  },[]);
  



  const handleSubmit = async (event) => {
    event.preventDefault();
    debugger
    if (selected === null) {
      alert('Please choose a plan');
    }else{
  
      sessionStorage.setItem('seletedplan' , JSON.stringify(selected))
      await createQuote(event);
   

    }
  }



  const handleBack = async (event) => {

    debugger
      event.preventDefault();
    window.location.href ='/dhofar-motoroffers'
  }


    useEffect(() => {
  
      const postvData = { organization_name: "Superjet" };
      debugger
  
      if (vendorKey === '' || vendorKey === null || vendorKey === undefined) {
  
        debugger
        fetch(base_url + '/create_organization', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(postvData),
        })
          .then(response => response.json())
          .then(data => {
            setVendorkey(data.result[0].vendor_key);
          })
          .catch(error => {
            console.error('Error posting data:', error);
          });
  
  
      }
    }, [vendorKey]);
  
  const [planDetails,setPlanDetails]=useState(null);
  const [motorFormDetails,setMotorFormDetails]=useState(null);
  const [personalInfo,setPersonalInfo]=useState(null);
  useEffect(()=>{
    const motorForm=sessionStorage.getItem("Motor_Form_Details");
  const personal=sessionStorage.getItem("motorinsurancePlan")

  // if(planvalue !== undefined) {
  //   const parsePlan = JSON.parse(planvalue)
  //   setPlanDetails(parsePlan)
  // }
  if(motorForm !== undefined) {
    const parseMotor = JSON.parse(motorForm)
    setMotorFormDetails(parseMotor)
  }
  if(personal !== undefined) {
    const parsePersonal = JSON.parse(personal)
    setPersonalInfo(parsePersonal)
  }
  },[])
const createQuote=async(e)=>{
  e.preventDefault();
  // const planvalue = sessionStorage.getItem('selectedPlan');
  
  debugger
  const product_id=selected?.planType.toLowerCase() ==="comprehensive"? "0501":"0502";
  const quoteReqData={
    product:product_id,
    riskType:selected.planId ,
    plateNo:motorFormDetails.plate_number,
    registrationMark:motorFormDetails.registration_mark,
    srcBusId: "BOT",
    chasisNo: motorFormDetails.chasis_no || "",
    plateRegType:motorFormDetails.plate_reg_type,
    vehicleValue:motorFormDetails.vehicle_value,
    civilId:motorFormDetails.civil_id,
    mobileNo:personalInfo.contactno,
    emailId:personalInfo.email,
    firstName:personalInfo.first_name,
    lastName:personalInfo.last_name
}
try{
    const response=await fetch(base_url+"/create_new_quote",{
      method:"POST",
      headers:{
        Authorization:`Bearer ${vendorKey}`,
        'Content-Type':"application/json"
      },
       body:JSON.stringify(quoteReqData)
    });
    if(!response.ok){
      console.log("creating  quote HTTP status :",response.status )
    }
    const data= await response.json();
    if(data.message==="success"){

      if(data.result.effectiveDt ){
        const quote_info=data.result;
          const session_data={
            civilId:quote_info?.insuredDetails?.insuredLicNo,
            plateNo: quote_info?.vehicleDetails?.vehRegNo,
            registrationMark:quote_info?.vehicleDetails?.vehRegLOC,
            srcBusId: "BOT",
            txnTyp:"Q",
            mobileNo:quote_info?.insuredDetails?.insuredMobileNo,
            policyNo:quote_info?.renewalQuoteNo ||"107/0502/2025/Q/000742",
            quoteNo:""
        }
        sessionStorage.setItem("getQuoteInput",JSON.stringify(session_data));
         window.location.href ='/dhofar-motor-quote'
      }
      else{
      alert(data.result.errMsg);
      window.location.href ='/dhofar-motoroffers'
      }
    //  console.log('====================================');
    //  console.log(data.result);
    //  console.log('====================================');
    }
  }catch(err){
    console.log("err at creating quote : ",err)

  }
    
}



  return (
    <Fragment>

      <div className="header_section1">

        <Navbar />


        <div className="container-fluid bg-breadcrumb">
          <div className="container text-center py-5">
            <h3 className="abt-txt my-3">{(lnstr === 'en') ? 'Third Party' : 'طرف ثالث\n'}</h3>
          </div>
        </div>


      </div>


      <div className="features_section">
        <div className="container">

          <div className="row">

            <Col md={3}></Col>

            <Col md={6} className="myforms my-5" data-aos='fade-up'>



              <h4 className="px-0 py-2">{(lnstr === 'en') ? 'Select plan' : 'اختر الخطة\n'}</h4>

              <form>
                <div class="align-items-center travel-selection-option">
                  {(lnstr === 'en') ? 'Basic + Driver + Family (PAB)' : 'أساسي + سائق + عائلة (PAB)\n'}
                  <input type="radio" name="0502" data-name="050008" value="Basic + Driver + Family (PAB)" className="d-inline-block option-circle ml-auto" onChange={handleOptionChange} />
                </div>

                <div class="align-items-center travel-selection-option my-3">
                  {(lnstr === 'en') ? 'Basic + Driver + Family (PAB) + UAE' : 'أساسي + سائق + عائلة (PAB) + الإمارات العربية المتحدة\n'}
                  <input type="radio" name="0502" data-name="050009" value="Basic + Driver + Family (PAB) + UAE" className="d-inline-block option-circle ml-auto" onChange={handleOptionChange} />
                </div>
                <div class="align-items-center travel-selection-option my-3">
                  {(lnstr === 'en') ? 'Basic + Driver + Family (PAB) + RSA' : 'أساسي + سائق + عائلة (PAB) + RSA\n'}
                  <input type="radio" name="0502" data-name="050017" value="Basic + Driver + Family (PAB) + RSA" className="d-inline-block option-circle ml-auto" onChange={handleOptionChange} />
                </div>
                <div class="align-items-center travel-selection-option my-3">
                  {(lnstr === 'en') ? 'Basic + Driver + Family (PAB) + UAE + RSA' : 'أساسي + سائق + عائلأساسي + سائق + عائلة (PAB) + الإمارات العربية المتحدة + RSA\n'}
                  <input type="radio" name="0502" data-name="050018" value="Basic + Driver + Family (PAB) + UAE + RSA" className="d-inline-block option-circle ml-auto" onChange={handleOptionChange} />
                </div>
              </form>

              <div>
              <button type="submit" disabled={buttonDisabled} className="rounded-pill text-white my-1 py-1 px-4" style={{
            backgroundColor: isHovered ? '#0b8ba8' : '#33d0f2',
            transition: 'background-color 0.3s ease',
            position: 'absolute', 
            right: '10px',
          }} onClick={handleSubmit}  onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>{(lnstr === 'en' ? 'Get Quote' : 'الحصول على الاقتباس')}</button>

<button type="submit" disabled={buttonDisabled} className="rounded-pill text-white my-1 py-1 px-4" style={{
            backgroundColor: isHovered1 ? '#0b8ba8' : '#33d0f2',
            transition: 'background-color 0.3s ease',
          }} onClick={handleBack}  onMouseEnter={() => setIsHovered1(true)} onMouseLeave={() => setIsHovered1(false)}>{(lnstr === 'en' ? 'Back' : 'خلف')}</button>
              </div>


            </Col>

            <Col md={3}></Col>

          </div>

        </div>
      </div>

      <Footer />

      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}

    </Fragment>
  );
}

export default MotorInsuranceThirdParty;
